/* eslint-disable class-methods-use-this */
import LanguageAction from '../actions';
import BaseReducer from '../../../utilities/BaseReducer';

export default class LanguageReducer extends BaseReducer {
  initialState = {
    language: 'es'
  };

  [LanguageAction.SET_LANGUAGE_FINISHED](state, action) {
    return {
      ...state,
      language: action.payload
    };
  }
}
